import { PaymentPricing } from '@/types/payment-account';
import { formatFeeSummary } from './shared';

/** Textos de "Configurar recebimento" (plano, seção 6.5). */

export const SETTINGS_METHODS = {
  title: 'Formas aceitas',
  pixLabel: 'Pix',
  cardLabel: 'Cartão',
  boletoLabel: 'Boleto',
};

/** Taxa ao lado de cada forma (seção 6.5, item 1). */
export function getSettingsMethodFee(
  method: 'pix' | 'card' | 'boleto',
  pricing: PaymentPricing,
): string {
  if (method === 'pix') return formatFeeSummary({ percent: pricing.fee.pixPercent, fixed: 0 });
  if (method === 'card')
    return formatFeeSummary({ percent: pricing.fee.cardPercent, fixed: pricing.fee.cardFixed });
  return formatFeeSummary({ percent: 0, fixed: pricing.fee.boletoFixed });
}

export const SETTINGS_ACCOUNT = {
  title: 'Conta bancária e cadastro',
  helper:
    'Trocar banco ou corrigir um dado é sempre por aqui — direto com o provedor de pagamento, dentro do app.',
};

export const SETTINGS_DEACTIVATE = {
  title: 'Desligar recebimento automático',
  body: 'Suas cobranças em aberto voltam para o Pix copia-e-cola e o link do seu perfil. O que já está liberando continua caindo normalmente até o fim do prazo.',
  confirmButton: 'Desligar',
  cancelButton: 'Manter ligado',
};

/** Card "Cobrança automática" (liga/desliga, T6.4) — status e nota de quem só acompanha. */
export const SETTINGS_COLLECTION = {
  title: 'Cobrança automática',
  onStatus: 'Ligada',
  offStatus: 'Desligada',
  /** `!account.chargesEnabled`: nada a fazer ainda, sem oferecer o botão de ligar. */
  pendingNote: 'Fica disponível quando o cadastro for aprovado.',
  /** Quem só acompanha (`!canManage`) vê o status, sem os botões. */
  readOnlyNote: 'Só quem gerencia os pagamentos liga ou desliga.',
};

/** Forma que a subconta ainda não habilita (`pixEnabled`/`cardEnabled`/`boletoEnabled` falso) — a escolha fica sem efeito até lá (seção 6.5, nota da T6.1). */
export const SETTINGS_METHOD_UNAVAILABLE_NOTE = 'Ainda não disponível nesta conta';

/** `usePaymentPricing()` sem dado (erro, ex.: 403 de quem não gerencia — T7.1) — a linha continua aparecendo, só sem a taxa. */
export const SETTINGS_METHOD_FEE_UNAVAILABLE_NOTE = 'Taxa indisponível';

export const SETTINGS_HELP_LINK = 'Como funciona';

/** Estado do recebimento automático em "Configurações da equipe" (T7.2, caixa único: só existe UMA subconta, a do dono). */
export const TEAM_PAYMENT_STATUS = {
  title: 'Recebimento automático',
  body: 'Todo mundo da equipe cobra pela mesma conta.',
  notStarted: 'Ainda não ativado',
  activateButton: 'Ativar recebimento automático',
  manageButton: 'Configurar recebimento',
  /** Quem vê a tela mas não gerencia (revisão da T7.2: `can('team')` não é `canManage`) — sem botão, só a frase. */
  readOnlyNote: 'Só o dono ativa ou muda.',
};

/** Detalhe do profissional, modo "por profissional" (T7.2, plano 4.7): só mostra, o dono não gerencia a subconta dele. */
export const MEMBER_PAYMENT_STATUS = {
  title: 'Recebimento automático',
  body: 'Cada um ativa e recebe na própria conta.',
  notStarted: 'Ainda não ativou',
  /** Erro na consulta (rede, 403) — nunca vira "não ativou" (revisão da T7.2: seria uma afirmação falsa). */
  loadError: 'Não foi possível ver agora',
};
